import { create } from "sheetly";
export let text = ".cover-layout{display:flex;justify-content:center}.cover-container{view-transition-name:song-cover;border:8px solid var(--difficulty)}.cover{width:128px;height:128px}";
export const sheet = create(text, import.meta.url);
